<template>
    <div role="main" class="main code-of-conduct">
        <div v-if="ready==false" class="loader">
            <div class="container">
                <div class="row">
                    <div class="col-sm-1 mx-md-auto text-center">
                        <spring-spinner
                        :animation-duration="3000"
                        :size="60"
                        color="#124191"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="container">
                <div class="row mt-5" v-html="content"></div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { SpringSpinner  } from 'epic-spinners'

export default {
    name: 'Conduct',
    components: {
    },
    data(){
        return{
            content: '',
            ready: false,
        }
    },
    methods: {
        getConent(){
            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/code_of_conduct')
                .then(response => {
                    this.content = response.data.data[0].content;
                })
                .then(response => {
                    this.ready = true;
                })
                
        },
    },
    created(){
        this.getConent();
    },
}
</script>

<style lang="scss">
.code-of-conduct{
    p{
        background: url('~@/assets/img/paragraph.png') center left no-repeat;
        padding-left: 70px;
        font-size: 1.3rem;
        font-weight: 300;
        color: #000;
        a{
            color: #124191;
            font-weight: 400;
            text-decoration: none;
            &:hover{
                text-decoration: underline;
            }
        }
    }
}
</style>